import { useEffect } from "react";
import { toast } from "react-toastify";
import { SignalRRateImportResponse } from "@/main/models/common/signalRReceiveUpdatesResponse";

interface HubItemRateImportProps {
	data: SignalRRateImportResponse[];
}

const HubItemRateImport = ({ data }: HubItemRateImportProps) => {
	useEffect(() => {
		if (data && data.length > 0) {
			const lastUpdate = data[data.length - 1];

			if (lastUpdate.isSuccess && lastUpdate.message) {
				toast.success(lastUpdate.message);
			} else if (!lastUpdate.isSuccess && lastUpdate.message) {
				toast.error(lastUpdate.message);
			}
		}
	}, [data]);

	return null;
};

export default HubItemRateImport;
